"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const ReactDOM = require("react-dom");
const MapView_1 = require("./map/MapView");
ReactDOM.render(React.createElement(MapView_1.MapView, null), document.getElementById("root"));



//////////////////
// WEBPACK FOOTER
// ./src/index.tsx
// module id = 306
// module chunks = 0